import { Link } from "react-router-dom";
import { TrendingUp, TrendingDown, Minus } from "lucide-react";

const fmt = (v) => (typeof v === "number" ? v.toLocaleString("it-IT", { maximumFractionDigits: 2 }) : "—");
const fmtDate = (d) => (d ? new Date(d.slice(0, 10) + "T00:00:00").toLocaleDateString("it-IT", { day: "numeric", month: "short", year: "numeric" }) : "—");

export default function AthleteTestSummary({ athleteId, summary }) {
  const items = summary?.items || [];
  return (
    <div className="bg-white border border-zinc-200 rounded-md p-5" data-testid="athlete-test-summary">
      <div className="flex items-center justify-between mb-3 flex-wrap gap-2">
        <h2 className="font-heading font-semibold">Test CSP Lab · sintesi longitudinale</h2>
        <Link to={`/test?tab=history&athlete=${athleteId}`} data-testid="test-summary-full-history" className="text-xs uppercase tracking-wider text-[#0052FF] hover:underline">Vedi storico completo →</Link>
      </div>
      {items.length === 0 && <div className="text-sm text-zinc-500">Nessun test registrato per questo atleta.</div>}
      {items.length > 0 && (
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="text-[10px] uppercase tracking-wider text-zinc-500">
              <tr>
                <th className="text-left px-2 py-2">Test</th>
                <th className="text-right px-2 py-2">Ultimo</th>
                <th className="text-right px-2 py-2">Precedente</th>
                <th className="text-right px-2 py-2">Best</th>
                <th className="text-right px-2 py-2">Variazione</th>
                <th className="text-right px-2 py-2">N</th>
                <th className="text-left px-2 py-2">Ultimo test</th>
                <th className="px-2 py-2" />
              </tr>
            </thead>
            <tbody>
              {items.map((it) => {
                const Icon = it.delta == null ? null : it.delta === 0 ? Minus : it.improved == null ? null : it.improved ? TrendingUp : TrendingDown;
                const tone = it.delta == null || it.improved == null ? "text-zinc-500" : it.delta === 0 ? "text-zinc-500" : it.improved ? "text-emerald-600" : "text-red-600";
                return (
                  <tr key={`${it.test_id}-${it.unit}-${it.side || ""}`} className="border-t border-zinc-100" data-testid={`test-summary-row-${it.test_id}`}>
                    <td className="px-2 py-2">
                      <div className="font-medium">{it.test_name}{it.side ? <span className="text-zinc-500 text-xs"> · {it.side}</span> : null}</div>
                      <div className="text-[10px] text-zinc-500 font-mono">{it.unit}{it.last_equipment ? ` · ${it.last_equipment}` : ""}{it.equipment_changed ? " · strumenti diversi" : ""}</div>
                    </td>
                    <td className="px-2 py-2 text-right font-mono font-semibold" data-testid={`test-summary-last-${it.test_id}`}>{fmt(it.last)} <span className="text-xs text-zinc-500">{it.unit}</span></td>
                    <td className="px-2 py-2 text-right font-mono text-zinc-600" data-testid={`test-summary-prev-${it.test_id}`}>{fmt(it.previous)}</td>
                    <td className="px-2 py-2 text-right font-mono" data-testid={`test-summary-best-${it.test_id}`}>{it.best != null ? fmt(it.best) : <span className="text-[10px] uppercase text-zinc-400" title="Semantica del test da definire">n/d</span>}</td>
                    <td className={`px-2 py-2 text-right font-mono ${tone}`} data-testid={`test-summary-delta-${it.test_id}`}>
                      {it.delta == null ? <span className="text-[10px] uppercase">campione insuff.</span> : <span className="inline-flex items-center gap-1 justify-end">{Icon && <Icon className="w-3.5 h-3.5" />}{it.delta > 0 ? "+" : ""}{fmt(it.delta)} ({it.delta_pct > 0 ? "+" : ""}{it.delta_pct}%)</span>}
                    </td>
                    <td className="px-2 py-2 text-right font-mono">{it.count}</td>
                    <td className="px-2 py-2 text-xs text-zinc-600">{fmtDate(it.last_date)}</td>
                    <td className="px-2 py-2 text-right"><Link to={`/test?tab=history&athlete=${athleteId}&test=${it.test_id}`} className="text-xs text-[#0052FF] hover:underline whitespace-nowrap" data-testid={`test-summary-open-${it.test_id}`}>Apri analisi →</Link></td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
